import environment from 'environment';

class ChatService {
  constructor(CustomerApiService, StorageService, SessionService, TicketsApiService) {
    'ngInject';

    this.CustomerApiService = CustomerApiService;
    this.StorageService = StorageService;
    this.SessionService = SessionService;
    this.enableChatHistory = false;
    this.TicketsApiService = TicketsApiService;
  }

  initialize() {
    this.SessionService.session.subscribe((sessionDetails) => {
      if (sessionDetails) {
        this.enableZendeskChat();
      } else {
        this.disableZendeskChat();
      }
    });
  }

  enableChat() {
    let memberDetails = JSON.parse(this.StorageService.getItem('member_details'));
    let userId = memberDetails.user_id;
    let fullName = memberDetails.full_name;
    let email = memberDetails.email;
    let restoreId = '';

    if (this.enableChatHistory) {
      restoreId = this.StorageService.getItem('restore_id');
    }

    window.fcWidget.init({
      token: environment.FRESH_CHAT_TOKEN,
      host: environment.FRESH_CHAT_HOST,
      externalId: userId,
      restoreId: restoreId,
    });

    window.fcWidget.user.get((resp) => {
      let status = resp && resp.status;

      if (status !== 200) {
        window.fcWidget.user.setProperties({
          firstName: fullName,
          email: email,
          externalId: userId
        });

        if (this.enableChatHistory) {
          window.fcWidget.on('user:created', (resp) => {
            let status = resp && resp.status;
            let data = resp && resp.data;
            if (status === 200) {
              if (data.restoreId) {
                this.CustomerApiService.saveRestoreId({'restoreId': data.restoreId}).then(() => {
                });
              }
            }
          });
        }
      }
    });
  }

  enableZendeskChat() {
    let zeScript = document.createElement('script');
    zeScript.setAttribute('id', 'ze-snippet');
    zeScript.setAttribute('src', environment.ZENDESK_WIDGET_SCRIPT);

    this.TicketsApiService.fetchTicketToken().then((ticketDetails) => {
      window.zESettings = {
        webWidget: {
          authenticate: {
            chat: {
              jwtFn: function(callback) {
                callback(ticketDetails.token);
              }
            }
          }
        }
      };
      document.body.appendChild(zeScript);
      zeScript.onload = () => {
        zE('webWidget', 'show');
      };
    });
  }

  disableZendeskChat() {
    if (typeof zE !== 'undefined') {
      zE(function() {
        zE.logout();
        zE.hide();
      });
    } else {
      let zeScript = document.createElement('script');
      zeScript.setAttribute('id', 'ze-snippet');
      zeScript.setAttribute('src', environment.ZENDESK_WIDGET_SCRIPT);
      document.body.appendChild(zeScript);

      zeScript.onload = () => {
        zE('webWidget', 'show');
      };
    }
  }
}

export default ChatService;



// WEBPACK FOOTER //
// ./client/app/shared/chat/chat.service.js